'use strict';

import $ from 'jquery';
import ModalView from '../../js/components/ModalView';
import AddToCartModalTemplate from './templates/_AddToCartModal.hbs';
import config from '../../js/config';
import userService from '../../services/CartUserService';

const AddToCartModal = ModalView.extend({
  template: AddToCartModalTemplate,
  initialize() {
    AddToCartModal.__super__.initialize.apply(this, arguments);
    userService.getUserInfo().then((userData) => {
      this.userData = userData;
    });
  },

  initializeElements() {
    this.$modalContainer = this.$('.AddToCartModal.Modal-dialog');
    this.$lastElement = this.$('a.Button.Button--blue');
    this.$firstElement = this.$('a.Modal-close.Icon.Icon--cross');
    if (this.modalData) {
      this.buyButton = '#buy-' + this.modalData.products[0].partNo;
    }
  },

  onOpen() {
    this.initializeElements();
    this.$continueShoppingBtn = this.$el.find('.contShoppingBtn');
    this.urlRedirect = config.urls.cart.continueButton;
    this.$modalContainer.attr('aria-modal',true);
    this.$firstElement.attr('role','button');
    this.$modalContainer.focus();
    this.$firstElement.on('keydown',(e)=>{
      if (e.key === 'Tab' && e.shiftKey) {
        e.preventDefault();
        this.$lastElement.focus();
      }
    });
    this.$lastElement.on('keydown', (e)=>{
      if (e.key === 'Tab' && !e.shiftKey) {
        e.preventDefault();
        this.$firstElement.focus();
      }
    });
  },

  onClose() {
    this.$modalContainer.removeAttr('aria-modal');
    $(this.buyButton).focus();
  },

  assignRedirectUrl(url) {
    window.location.assign(url);
  },

  addQueryParamToCartUrl(url, key, value) {
    /* Query param can't be appended because of angular router.
     Must replace the # symbol with the query string then add the #
     back to the url, because that is what angular router queues off of.
     */
    return url.replace('#', `?${key}=` + value + '#');
  },

  urlify(url) {
    return url.replace('#', '%23');
  }

});

export default AddToCartModal;



// WEBPACK FOOTER //
// ./assets/components/Cart/AddToCartModal.js